import {useQueryClient} from "@tanstack/react-query";
import {useCallback} from "react";
import {createCode} from "../api/code/CodeService";
import {createCustomCode} from "../api/field/CustomCodeService";
import {useCacheRefresh} from "./useCacheRefresh";
import {CacheType} from "../constant/CodeSpecNum";

/**
 * gov_front useCodeHandlers — Selector updater.onCreate / onUpdate 용
 */
export function useCodeHandlers() {
    const queryClient = useQueryClient();
    const refreshCache = useCacheRefresh();

    const invalidateCodeLists = useCallback(async () => {
        await queryClient.invalidateQueries({queryKey: ["fetchData"], exact: false});
        refreshCache(CacheType.code);
    }, [queryClient, refreshCache]);

    const handleCodeCreate = useCallback(async (payload) => {
        const data = {
            parentId: payload.parentId,
            rootCodeId: payload.rootParentId ?? payload.rootCodeId,
            name: payload.name,
            parent: payload.parentId != null ? {id: payload.parentId} : undefined,
            minimumLevel: "EXCELLENT",
            targetLevel: "EXCELLENT",
        };

        const res = await createCode(data);
        if (res?.status === 200) {
            await invalidateCodeLists();
        }
        return res;
    }, [invalidateCodeLists]);

    const handleCodeUpdate = useCallback(async (payload) => {
        const res = await createCode({
            ...payload,
            rootCodeId: payload.rootParentId ?? payload.rootCodeId,
            parent: payload.parentId != null ? {id: payload.parentId} : undefined,
        });
        if (res?.status === 200) {
            await invalidateCodeLists();
        }
        return res;
    }, [invalidateCodeLists]);

    const handleCustomCodeCreate = useCallback(async (payload) => {
        const data = {
            parentId: payload.parentId,
            rootCodeId: payload.rootParentId ?? payload.rootCodeId,
            name: payload.name,
            parent: payload.parentId != null ? {id: payload.parentId} : undefined,
        };

        const res = await createCustomCode(data);
        if (res?.status === 200) {
            await invalidateCodeLists();
        }
        return res;
    }, [invalidateCodeLists]);

    return {handleCodeCreate, handleCodeUpdate, handleCustomCodeCreate, invalidateCodeLists};
}
